// extracted by mini-css-extract-plugin
module.exports = {"switch-wrapper":"stage_settings__switch-wrapper___3_P9D","switchWrapper":"stage_settings__switch-wrapper___3_P9D"};